import { useHistory } from "react-router-dom";
import Title from "../../components/title/Title";
import "./Profile.css";

const Profile = () => {
  const history = useHistory();

  const logout = () => {
    localStorage.clear();
    history.replace("/login");
  };

  return (
    <div id="profile">
      <Title text="פרופיל" />
      <button id="button" onClick={logout}>
        Logout
      </button>
    </div>
  );
};

export default Profile;
